import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table-responsive ms-3 mx-3" }
const _hoisted_2 = { class: "table table-hover table-row-dashed table-row-gray-300 table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_3 = { class: "fw-bolder text-muted" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-80px" }, "Email", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-80px" }, "Country", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "City", -1)
const _hoisted_8 = {
  key: 0,
  class: "min-w-100px"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "CV", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "Phone", -1)
const _hoisted_11 = {
  key: 1,
  class: "min-w-120px text-end"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_14 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_17 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 1,
  class: "text-dark fw-bolder fs-6 text-end"
}
const _hoisted_21 = ["onClick", "disabled"]
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Promote ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          (_ctx.showAppliedDate)
            ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Applied at"))
            : _createCommentVNode("", true),
          _hoisted_9,
          _hoisted_10,
          (_ctx.actionButtons)
            ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Actions"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicants, (applicant) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: applicant.id
          }, [
            _createElementVNode("td", null, [
              _createVNode(_component_router_link, {
                class: "text-dark fw-bolder text-hover-primary fs-6",
                to: `/users/${applicant.id}/personal`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`${applicant.first_name} ${applicant.last_name}`), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("a", {
                href: `mailto:${applicant.email}`,
                class: "text-dark fw-bolder fs-6 text-hover-primary"
              }, _toDisplayString(applicant.email), 9, _hoisted_12)
            ]),
            _createElementVNode("td", _hoisted_13, _toDisplayString(applicant.country), 1),
            _createElementVNode("td", _hoisted_14, _toDisplayString(applicant.city), 1),
            (_ctx.showAppliedDate)
              ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(applicant.created_at), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_17, [
              (applicant.documents.length > 0)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    target: "_blank",
                    href: applicant.documents[0].file_link
                  }, " View ", 8, _hoisted_18))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("a", {
                href: `tel:${applicant.phone}`,
                class: "text-dark fw-bolder fs-6 text-hover-primary"
              }, _toDisplayString(applicant.phone), 9, _hoisted_19)
            ]),
            (_ctx.actionButtons)
              ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "btn btn-success btn-sm",
                    onClick: ($event: any) => (_ctx.$emit('approveApplicant', applicant.id)),
                    disabled: _ctx.isAwaitingApproval.includes(applicant.id)
                  }, [
                    (_ctx.isAwaitingApproval.includes(applicant.id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                      : _createCommentVNode("", true),
                    _hoisted_23
                  ], 8, _hoisted_21)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}